import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Megaphone, Check, Loader2 } from "lucide-react";
import { DocAttachments } from "@/components/DocAttachments";

export default function ConsignesBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/consignes/mine");
      setItems(data.filter((c) => !(c.read_by || []).includes(user?.user_id)));
    } catch {}
  }, [user]);

  useEffect(() => { if (user?.role === "agent") load(); }, [user, load]);

  if (user?.role !== "agent" || items.length === 0) return null;

  const markRead = async (id) => {
    setBusy(id);
    try { await api.post(`/consignes/${id}/read`); setItems((s) => s.filter((c) => c.consigne_id !== id)); }
    catch {} finally { setBusy(null); }
  };

  return (
    <div className="px-4 sm:px-6 pt-4 space-y-3" data-testid="consignes-banner">
      {items.map((c) => (
        <div key={c.consigne_id} data-testid={`consigne-banner-${c.consigne_id}`}
          className="rounded-lg border border-[#FFB020]/40 bg-[#FFB020]/10 p-4 flex items-start justify-between gap-4">
          <div className="min-w-0 flex gap-3">
            <Megaphone className="w-5 h-5 text-[#FFB020] shrink-0 mt-0.5" />
            <div className="min-w-0">
              <p className="font-display font-semibold text-white">{c.titre}</p>
              <p className="text-zinc-300 text-sm mt-0.5 whitespace-pre-wrap">{c.texte}</p>
              {c.attachments?.length > 0 && <div className="mt-2 w-full max-w-md"><DocAttachments base={`consignes/${c.consigne_id}`} items={c.attachments} testPrefix={`banner-att-${c.consigne_id}`} /></div>}
            </div>
          </div>
          <Button size="sm" onClick={() => markRead(c.consigne_id)} disabled={busy === c.consigne_id}
            data-testid={`banner-read-${c.consigne_id}`} className="bg-[#FFB020] hover:bg-[#e69e17] text-black shrink-0">
            {busy === c.consigne_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Check className="w-4 h-4 mr-1.5" /> J'ai lu</>}
          </Button>
        </div>
      ))}
    </div>
  );
}
